module.exports = __webpack_public_path__ + "static/img/wayfair.df7d5c3d.jpg";